// Do not change unless you know what you are doing..
export const DEFAULT_LANG = 'eng';

export const FRACTION_ODDS_FORMAT = 'FRACTION';
export const DECIMAL_ODDS_FORMAT = 'DECIMAL';
export const AMERICAN_ODDS_FORMAT = 'AMERICAN';
export const MILLI_SECONDS_UNIT = 1000;
export const DAY_IN_HOURS = 24;
export const HOUR_IN_MINUTES = 60;
export const TODAY_I18N_KEY = 'sports.today';
export const TOMORROW_I18N_KEY = 'sports.tomorrow';
export const TODAY_STRING = 'Today';
export const TOMORROW_STRING = 'Tomorrow';
export const EMPTY_LENGTH_CHECK = 0;
export const DEFAULT_DECIMAL_PLACES = 2;
export const DEFAULT_LOCALE = 'en-GB';

export const MAX_SINGLE_DIGIT = 9;
export const DATE_TIME_PADDING = 0;
export const MONTH_INDEX_CORRECTION = 1;

export const HOME_SELECTION = '1';
export const DRAW_SELECTION = 'X';
export const AWAY_SELECTION = '2';
export const YES_SELECTION = 'Yes';
export const NO_SELECTION = 'No';
export const OVER_SELECTION = 'Over';
export const UNDER_SELECTION = 'Under';
export const HOME_SELECTION_ORDER = 1;
export const DRAW_SELECTION_ORDER = 2;
export const AWAY_SELECTION_ORDER = 3;
export const YES_SELECTION_ORDER = 1;
export const NO_SELECTION_ORDER = 2;
export const OVER_SELECTION_ORDER = 1;
export const UNDER_SELECTION_ORDER = 2;
export const TWO_WAY_MARKET_SELECTION_SCHEMA = 25;
export const THREE_WAY_MARKET_SELECTION_SCHEMA = 1;
export const SPECIAL_HEADERS_SPORT_SLUG_LIST = ['tennis', 'snooker', 'mma', 'darts', 'boxing'];

export const SELECTION_I18N_KEY_LABEL_ONE = 'mkt_headers.1';
export const SELECTION_I18N_KEY_LABEL_TWO = 'mkt_headers.2';
export const SELECTION_I18N_KEY_LABEL_HOME = 'mkt_headers.home';
export const SELECTION_I18N_KEY_LABEL_DRAW = 'mkt_headers.draw';
export const SELECTION_I18N_KEY_LABEL_AWAY = 'mkt_headers.away';
export const SELECTION_I18N_KEY_LABEL_DRAW_X = 'mkt_headers.x';
export const ALL_MARKETS_I18N_KEY = 'sport_event.all_markets';

export const FEATURED_MATCHES_ICON = 'featured';
export const UPCOMING_MATCHES_ICON = 'upcoming';

export const GTM_BET_CARD = 'bet-card';
export const GTM_FEATURED_MATCHES = 'featured-matches';
export const GTM_SEE_ALL_PREFIX = 'see-all-';
export const GTM_UPCOMING_MATCHES = 'upcoming-matches';
export const GTM_COMPETITIONS_PAGE = 'competitions-page';
export const DATE_TIME_DMYH_FORMAT = 'D MMM YYYY H:mm';

/**
 * Date and time formatting
 * These strings are based on IE/UK formats and are only identifiers - use them with getLocalizedDateFormat()
 * to get a locale specific format. e.g getLocalizedDateFormat(DATE_TIME_FORMAT_HM_DD_MMM_YYYY) gives us
 * '01:00 01 Jan 2000' by default, but '1:00am Jan 01, 2000' in USA.
 */
export const DATE_TIME_FORMAT_DEFAULT = 'Mon 01 Jan';
export const DATE_TIME_FORMAT_HM_DD_MMM_YYYY = '01:00 01 Jan 2000';
export const DATE_TIME_FORMAT_DD_MMM = '01 Jan';
export const DATE_TIME_FORMAT_DD_MMM_YYYY = '01 Jan 2000';
export const DATE_TIME_FORMAT_HM = '01:00';
export const DATE_TIME_FORMAT_DDDD = 'Monday';
export const DATE_TIME_FORMAT_DD = '01';
export const DATE_TIME_FORMAT_DDD = 'Mon';
export const DATE_TIME_FORMAT_DDD_DD_MMM = 'Mon, 01 Jan';

export const defaultDateFormats = {
    [DATE_TIME_FORMAT_DEFAULT]: 'ddd DD MMM',
    [DATE_TIME_FORMAT_HM_DD_MMM_YYYY]: 'HH:mm DD MMM YYYY',
    [DATE_TIME_FORMAT_DD_MMM]: 'DD MMM',
    [DATE_TIME_FORMAT_DD_MMM_YYYY]: 'DD MMM YYYY',
    [DATE_TIME_FORMAT_HM]: 'HH:mm',
    [DATE_TIME_FORMAT_DDDD]: 'dddd',
    [DATE_TIME_FORMAT_DD]: 'DD', // inplay schedule only - should not use
    [DATE_TIME_FORMAT_DDD]: 'ddd', // inplay schedule only - should not use
    [DATE_TIME_FORMAT_DDD_DD_MMM]: 'ddd, DD MMM',
};

export const dateFormats = {
    'default': defaultDateFormats,
    'USA': {
        [DATE_TIME_FORMAT_DEFAULT]: 'ddd MMM DD', // Mon Jan 01
        [DATE_TIME_FORMAT_HM_DD_MMM_YYYY]: 'h:mma MMM DD, YYYY', // 1:00am Jan 01, 2000
        [DATE_TIME_FORMAT_DD_MMM]: 'MMM DD', // Jan 01
        [DATE_TIME_FORMAT_DD_MMM_YYYY]: 'MMM DD, YYYY', // Jan 01, 2000
        [DATE_TIME_FORMAT_HM]: 'h:mma', // 1:00am
        [DATE_TIME_FORMAT_DDDD]: 'dddd', // Monday
        [DATE_TIME_FORMAT_DD]: 'DD', // 01 // inplay schedule only - should not use
        [DATE_TIME_FORMAT_DDD]: 'ddd', // Mon // inplay schedule only - should not use
        [DATE_TIME_FORMAT_DDD_DD_MMM]: 'ddd, MMM DD', // Mon, Jan 01
    },
};

export const LAST_CHUNK = 1;

export const TIMEAGO_PREFIX = 'timeago';
export const TIMEAGO_DEFAULT_REFRESH_INTERVAL = 30;

export const TIMEAGO_OPTIONS = [
    'just_now', 'less_then_min', 'one_min', 'x_mins', 'one_hour', 'x_hours',
    'one_day', 'x_days', 'one_week', 'x_weeks', 'one_month', 'x_months', 'one_year',
    'x_years',
];

export const THREE_MARKET_HEADERS = {
    'american-football': ['spread', 'total', 'money-line'],
    'basketball': ['spread', 'total', 'money-line'],
    'ice-hockey': ['puck-line', 'total', 'money-line'],
    'baseball': ['run-line', 'total', 'money-line'],
};

// Selections
export const SELECTION_ODDS_DECIMAL_PRECISION_HIGHER = 3;
export const SELECTION_ODDS_DECIMAL_PRECISION_LOWER = 2;

// Sport Slugs
export const CRICKET_SLUG = 'cricket';
export const DARTS_SLUG = 'darts';
export const SNOOKER_SLUG = 'snooker';

export const GIBRALTAR_REGULATION_ID = 4;
export const GERMAN_REGULATION_ID = 11;
export const MALTA_REGULATION_ID = 16;
export const COLORADO_REGULATION_ID = 20;
export const ONTARIO_REGULATION_ID = 21;
export const VIRGINIA_REGULATION_ID = 23;
